import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CountertopsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"countertops"}/>
}
